import { connect } from 'react-redux';
import { setProfile } from 'app/dux/profile/actions';
import App from './app';

export default connect( null, { setProfile } )( App );
